module.exports = __webpack_public_path__ + "img/mood-icon-6.96050bad.svg";